import { ReactElement, useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { Alert, TileRadioAccessible } from '@components';
import FormSubmissionSuccessAlertContent from '@components/Content/AlertContent/FormSubmissionSuccessAlertContent';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';
import { tile } from '@interfaces/interfaces';
import { navToError } from '@utils/Navigation';
import { useLocation, useNavigate } from 'react-router-dom';

import DoneIcon from '../../../../images/done.svg';
import InfoIcon from '../../../../images/info.svg';

const { REACT_APP_SITECORE_API_ENDPOINT: API_URL } = process.env;

function InfringementExtStep10(): ReactElement {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  const location = useLocation();
  const navigate = useNavigate();
  const currentDomain = window.location.origin;
  const currentFormName = 'Infringement Ext'; // due to DB limitation only 20 chars allowed
  const [referenceID, setreferenceID] = useState('00000000-0000-0000-0000-000000000000');
  const [surveyUrl, setSurveyUrl] = useState(`${currentDomain}/survey?Source=${currentFormName}&Id=${referenceID}`);
  const [feedbackOptions, setFeedbackOptions] = useState({});
  let emailAddress;
  let pageLoad = 0;
  // eslint-disable-next-line no-unused-expressions
  values.isDebtorTypeIndividual
  ? emailAddress = values.IndividualEmail! : emailAddress = values.CompanyEmail!;
  // eslint-disable-next-line no-unused-expressions, no-nested-ternary
  const sendEmailCopy = values.isDebtorTypeIndividual
  ? ((!values.IndividualHasNoEmail && values.IndividualEmailTo === 'true') ? 'true' : 'false') : ((!values.CompanyHasNoEmail && values.CompanyEmailTo === 'true') ? 'true' : 'false');
  const submissionNumber = values.submissionNo!;
  const DifficultMessage = (): ReactElement => (
    // TODO - Connect to Sitecore to make this content manageable.
    <>
      <span>
        How can we improve? Would you like to
        {' '}
        <a href={surveyUrl} title="Take a survey" aria-label="Go to Survey">
          take a survey
        </a>
        {' '}
        ?
      </span>
    </>
  );
  const getKeyByValue = (object: {[key: string]: string}, value: string) => Object.entries(object).find(([, v]) => v === value)?.[0];
  const TILE_DATA: tile[] = feedbackOptions
  ? Object.values(feedbackOptions).map((option) => ({
      body: <><div>{option as string}</div></>,
      value: (option as string),
    }))
  : [];

  useEffect(() => {
    if (!submissionNumber) navToError(navigate, location);
  }, []);

  useEffect(() => {
    async function fetchData() {
      const feedbackOptionID = feedbackOptions ? getKeyByValue(feedbackOptions, values.FormExperience) : '{00000000-0000-0000-0000-0000000000}';
        try {
          const currentDT = new Date().toISOString();
          const response = await fetch(`${API_URL}sitecore/Feedback/UpdateFeedbackForm`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              ReferenceId: referenceID,
              Source: currentFormName,
              Date: currentDT,
              SitecoreItemId: feedbackOptionID,
              Value: values.FormExperience,
              IsSurveyCompleted: false
          })
          });
          const data = await response.json();
          const referenceIdRes = data;
          // Update the message state with the API response
          setreferenceID(referenceIdRes);
          setSurveyUrl(`${currentDomain}/survey?Source=${currentFormName}&Id=${referenceIdRes}`);
        } catch (error) {
          console.log('Error fetching data:', error);
        }
      }
      async function fetchOptions() {
          try {
            const response = await fetch(`${API_URL}sitecore/Feedback/getFeedbackOptions`, {
              method: 'GET',
            });
            const data = await response.json();
            const parsedData = JSON.parse(data);
            setFeedbackOptions(parsedData);
            console.log(parsedData);
          } catch (error) {
            console.log('Error fetching data:', error);
          }
        }
        if (Object.keys(feedbackOptions).length === 0 && feedbackOptions.constructor === Object && pageLoad === 0) {
          fetchOptions();
          pageLoad += 1;
        }
    if (values.FormExperience !== undefined && values.FormExperience !== '') {
      fetchData();
    }
  }, [values.FormExperience]);
  return (
    <div>
      <span className="vfH2">Your application has been successfully submitted</span>
      <Alert
        title="For your records"
        message={<FormSubmissionSuccessAlertContent submissionNumberAlertInfo={submissionNumber as string} email={emailAddress as string} hasEmailCopy={sendEmailCopy} />}
        icon={DoneIcon}
        theme="success"
        color="green"
      />
      <Alert
        title="What will happen next?"
        message="Once a decision has been made on your application, Fines Victoria will notify you of the outcome. If your application is successful, you will have 28 days to nominate, request to go to court or otherwise deal with your infringement."
        icon={InfoIcon}
        theme="info2"
      />
      <Field
        name="FormExperience"
        title="What was it like completing this form today?"
        component={TileRadioAccessible}
        tileData={TILE_DATA}
        orientationRow
        isMandatory
      />
      {values.FormExperience === 'Difficult'
      && (
        <>
          <Alert
            title=""
            message={<DifficultMessage />}
            icon={InfoIcon}
            theme="info2"
          />
        </>
      )}
      {(values.FormExperience && values.FormExperience !== 'Difficult')
      && (
        <>
          <Alert
            title=""
            message="Thanks for your feedback!"
            icon={DoneIcon}
            theme="success"
          />
        </>
      )}
    </div>
  );
}

export default InfringementExtStep10;
